var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73451 2.59901C10.7414 0.855018 13.2586 0.855018 14.2655 2.59901L23.6108 18.7854C24.6176 20.5294 23.359 22.7094 21.3452 22.7094H2.6548C0.641013 22.7094 -0.617602 20.5294 0.38929 18.7854L9.73451 2.59901Z",
    fill: "#FEA51E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3877 9.07333C10.3347 8.33132 10.9223 7.70018 11.6662 7.70018H12.7584C13.5023 7.70018 14.09 8.33132 14.037 9.07334L13.5792 15.4825C13.5313 16.1533 12.9731 16.673 12.3006 16.673H12.124C11.4515 16.673 10.8934 16.1533 10.8454 15.4825L10.3877 9.07333Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4941 19.2367C13.4941 19.9446 12.9203 20.5185 12.2123 20.5185C11.5044 20.5185 10.9305 19.9446 10.9305 19.2367C10.9305 18.5287 11.5044 17.9548 12.2123 17.9548C12.9203 17.9548 13.4941 18.5287 13.4941 19.2367Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningicon);
export default __webpack_public_path__ + "static/media/warning.icon.fa7a54d804dfd759857b23fccf8fe3a7.svg";
export { ForwardRef as ReactComponent };